import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TopToolbarStateService {
  private mapNameSignal = signal<string | undefined>(undefined);
  readonly mapName$ = this.mapNameSignal.asReadonly();

  setMapName(name: string | undefined) {
    this.mapNameSignal.set(name);
  }

}
